<template>
  <div>
    <div
      class="list"
      :style="{ 'padding': index > 0 && clientWidth > 1200 ? '12px 0' : '10px 0' }"
      v-for="(item, index) in dataList"
      :key="index"
      @click="goArticle(item.id)"
    >
      <div class="list-content">
        <div class="list-title">{{ item.title }}</div>
        <div class="list-text" v-if="item.brief">{{ item.brief }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: Array
  },
  computed: {
    clientWidth() {
      return document.body.clientWidth;
    }
  },
  methods: {
    goArticle(id) {
      this.$router.push({
        name: "articleList",
        query: {
          type: "article",
          selectMenuId: this.$route.query.selectMenuId,
          selectMoreId: this.$route.query.selectMoreId,
          selectThreeId: this.$route.query.selectThreeId,
          articleId: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  cursor: pointer;
  border-bottom: 1px dashed #666;
  &-content {
    width: 716px;
    margin-left: 16px;
  }
  &-title {
    font-size: 20px;
    color: #333;
    &:hover {
      color: #ff9240;
    }
  }
  &-text {
    font-size: 14px;
    display: -webkit-box;
    color: #666;
    margin-top: 10px;
    line-height: 18px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}
</style>
